__turbopack_context__.v({
  "content": "style-module-scss-module__EtCfFq__content",
  "content-container": "style-module-scss-module__EtCfFq__content-container",
  "content-container__reverse-direction": "style-module-scss-module__EtCfFq__content-container__reverse-direction",
  "description": "style-module-scss-module__EtCfFq__description",
  "illustration": "style-module-scss-module__EtCfFq__illustration",
  "illustration-1": "style-module-scss-module__EtCfFq__illustration-1",
  "illustration-2": "style-module-scss-module__EtCfFq__illustration-2",
  "illustration-3": "style-module-scss-module__EtCfFq__illustration-3",
  "illustration-4": "style-module-scss-module__EtCfFq__illustration-4",
  "illustration-5": "style-module-scss-module__EtCfFq__illustration-5",
  "illustration__hidden-placeholder": "style-module-scss-module__EtCfFq__illustration__hidden-placeholder",
  "kids": "style-module-scss-module__EtCfFq__kids",
  "learn-more": "style-module-scss-module__EtCfFq__learn-more",
  "number": "style-module-scss-module__EtCfFq__number",
  "number-icon": "style-module-scss-module__EtCfFq__number-icon",
  "step": "style-module-scss-module__EtCfFq__step",
  "step-number": "style-module-scss-module__EtCfFq__step-number",
  "step-title": "style-module-scss-module__EtCfFq__step-title",
});
